<template>
	<div class="personal">

		<el-form :model="formData" :rules="rules" :hide-required-asterisk="true" ref="personal">
			<el-row :gutter="10">
				<el-col :span="24">
					<div class="insert-title">第一步、產品選擇</div>
				</el-col>
				
				<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
					<el-form-item prop="package" label="產品內容">
						<el-radio-group v-model="packageValue" :disabled="Boolean(formData.id)">
							<el-radio border v-for="(item, index) in packageOptions.filter(i => i.type=='M22')"
								:label="item.value">
								{{item.label}}
							</el-radio>
						</el-radio-group>
					</el-form-item>
				</el-col>

				<el-col :span="24">
					<div class="insert-title">第二步、填寫訂單信息與個人信息</div>
				</el-col>
				<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
					<el-form-item prop="ord_no" label="訂單號(若沒有訂單號，可隨意填寫，訂單號僅做記錄與查詢使用)">
						<div class="open-item-tip" v-show="isShowPhone">{{formData.ord_no}}</div>
						<el-input :disabled="Boolean(formData.id)" v-model.trim="formData.ord_no" type="text"
							placeholder="請輸入訂單號" @input="ordNoMustStr" :maxlength="30"></el-input>
					</el-form-item>
				</el-col>
				<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
					<el-form-item prop="name" label="姓名">

						<el-input v-model.trim="formData.name" type="text" :maxlength="20" placeholder="請輸入姓名"></el-input>
					</el-form-item>
				</el-col>
				
				<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
					<el-form-item prop="sex" label="用戶性別">

						<el-select v-model="formData.sex">
							<el-option label="男" :value="1"></el-option>
							<el-option label="女" :value="2"></el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
					<el-form-item prop="birth" label="出生日期">
						<el-date-picker v-model="birthSel" type="date" placeholder="請選擇" value-format="yyyy/MM/dd"
							format="yyyy/MM/dd" @change="handleBirth" :default-value="new Date('1990/1/1')">
						</el-date-picker>
					</el-form-item>
				</el-col>

				<el-col :span="24">
					<div class="footer-btn">
						<el-button @click="next" class="next qjc-fts-16 qjc-block">下一步</el-button>
					</div>
				</el-col>
			</el-row>
		</el-form>
	</div>
</template>

<script>
	import {
		isPhone
	} from '../../../utils'
	import {
		getPackage,
		enterpriseList,
		isHKPhone,
		newQuestionsSubmit,
		getGoodsList
	} from '../../../js/axios'

	export default {
		name: 'personal',
		data() {


			// 出生日期验证
			var birthVerify = (rule, value, callback) => {
				if (this.birthSel && (new Date(this.birthSel).getTime() > this.limitTime(90)) && (new Date(this
						.birthSel).getTime() <= this.limitTime(20))) {
					callback();
				} else {
					callback(new Error('大數據評估僅適用於年齡在20~90周歲之間人群!'));
				}
			}



			// 基础套餐必选
			var examBasicVerify = (rule, value, callback) => {
				callback()

			}

			return {


				yyuseridConfirm: '', // 企业用户id确认
				yyuseridConfirmErr: false, // 手机号确认错误消息显示

				rules: {
					name: [{
						required: true,
						message: '請輸入姓名',
						trigger: 'blur'
					}],

					// 暂时修改为提交订单号，不做手机号码的校验
					ord_no: [{
						required: true,
						message: '請輸入訂單號',
						trigger: 'blur'
					}],
					// 性别:1男  2女
					sex: [{
						required: true,
						message: '請選擇客戶性別',
						trigger: 'blur'
					}],
					birth: [{
							required: true,
							message: '請選擇出生日期',
							trigger: 'blur'
						},
						{
							validator: birthVerify,
							trigger: 'change'
						}
					],

					package: [{
						validator: examBasicVerify,
						trigger: 'change'
					}],
				},
				isShowPhone: false,
				packageValue: '',
				isSuper: 0,
				packageOptions: [],
				packageType: 'M22',
			}
		},
		computed: {
			birthSel: { // 出生日期展示
				get() {
					if (this.formData.birth) { //不能为空
						// 时间戳妙转为毫秒
						return this.formData.birth;
					} else {
						return '';
					}

				},
				set(value) {
					// 毫秒转换为秒
					this.formData.birth = value;

				}
			},
			examdateSel: { // 体检日期展示
				get() {
					if (this.formData.examdate) { //不能为空
						// 时间戳妙转为毫秒
						return this.formData.examdate * 1000;
					} else {
						return '';
					}
				},
				set(value) {
					// 毫秒转换为秒
					this.formData.examdate = value / 1000;
				}
			}
		},
		props: ['type', 'isBo', 'formData', 'reportCode'],
		inject: ['handleRefresh'],
		mounted() {
			setTimeout(() => {
				if(this.formData.goods_id){
					this.packageValue = this.formData.goods_id
				}
				if (this.formData.sex != '') {
					this.formData.sex = Number(this.formData.sex)
				}
			}, 100)
			this.handleGoodsList()
		},
		watch: {
			packageValue(newVal) {
				this.formData.goods_id = newVal
				/* if (newVal == '6') {
					this.$emit('handleHasBo', false)
					this.$emit('handleIsM22', false)
					delete this.rules.name
				}
				if (newVal == '7' || newVal == '8') {
					this.$emit('handleHasBo', true)
					this.$emit('handleIsM22', false)

					delete this.rules.name
				} */
				this.packageOptions.map((item) => {
					if (item.value == newVal && item.type == 'M22') {
						this.$emit('handleHasBo', false)
						this.$emit('handleIsM22', true)
						this.packageType = 'M22'

					}
				})
			},

		},
		methods: {

			handleGoodsList() {
				let data = {}
				// return
				getGoodsList(data).then((res) => {
					if (res.code == 200) {
						let goodsList = JSON.parse(window.atob(res.data))
						let list = []

						goodsList.map((goods) => {
							list.push({
								value: goods.id,
								label: goods.name,
								price: goods.price,
								type: goods.type,
							})
						})
						if(!this.packageValue && list.filter(i => i.type=='M22').length){
							this.packageValue = list.filter(i => i.type=='M22')[0].value
						}
						this.packageOptions = list
					}
				})
			},
			check_num() {
				if (this.formData.yyuserid) {
					this.formData.yyuserid = this.formData.yyuserid.replace(/[^\a-\z\A-\Z0-9]/g, '');
				}
			},
			handleBirth(val) {
			},
			// 下一步
			next() {
				/* if (this.packageValue == '6') {
					this.$emit('handleHasBo', false)
					this.$emit('handleIsM22', false)
				}
				if (this.packageValue == '7' || this.packageValue == '8') {
					this.$emit('handleHasBo', true)
					this.$emit('handleIsM22', false)
				} */
				if (this.packageType == 'M22') {
					this.$emit('handleHasBo', false)
					this.$emit('handleIsM22', true)
					this.formData.type = 'M22'
				}
				this.formData.goods_id = this.packageValue
				// 报告编码和输入框一致

				// return
				this.$refs.personal.validate((isSuc, err) => {
					// 验证通过且确认输入也通过
					if (isSuc) {
						if (this.packageValue == '' || this.packageValue == undefined || this.packageValue ==
							'undefined') {
							this.$myAlert({
								title: '請選擇套餐',
								content: '請選擇開通套餐'
							});
							return
						}

						this.$emit('stopQuery');

						// 成功进入下一步
						if (this.packageType == 'M22') {
							this.$emit('checkTab', 'Bodily');
						} else {
							this.$emit('checkTab', 'Questions');
						}

					}
				});

			},



			// 企业用户id确认
			yyuseridConfirmVerify() {
				if (this.yyuseridConfirm != this.formData.yyuserid) {
					this.yyuseridConfirmErr = true;
					return false;
				} else {
					this.yyuseridConfirmErr = false;
					return true;
				}
			},

			// 距今year年的时间戳 参数:year:距今年份
			limitTime(year) {
				let nowDate = new Date();
				return new Date((nowDate.getFullYear() - year) + '/' + (nowDate.getMonth() + 1) + '/' + nowDate.getDate())
					.getTime();
			},


			ordNoMustStr(value) {
				this.formData.ord_no = value.replace(/[^0-9a-zA-Z]/g, '');
			},

		}
	}
</script>

<style scoped>
	.el-form>>>.el-form-item__label {
		line-height: 36px;
	}

	.el-form .el-input>>>input,
	.el-form>>>.el-input__inner {
		max-width: 400px;
		height: 36px;
		line-height: 16px;
		font-size: 14px;
	}

	.el-form>>>.el-form-item__content,
	.el-form>>>.el-input__icon {
		line-height: 36px;
	}



	.product .el-checkbox,
	.product>>>.el-checkbox__input {
		position: absolute;
		top: 0;
		left: 0;
	}

	.product>>>.el-checkbox__inner {
		width: 18px;
		height: 16px;
		border-radius: 6px 0 6px 0;
	}

	.product>>>.el-checkbox__inner::after {
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%)rotate(45deg)scaleY(0);
	}

	.product>>>.el-checkbox__input.is-checked .el-checkbox__inner::after {
		transform: translate(-50%, -50%)rotate(45deg)scaleY(1);
	}

	.product>>>.el-checkbox__input.is-checked .el-checkbox__inner,
	.product>>>.el-checkbox__input.is-indeterminate .el-checkbox__inner {
		border-color: #6681FA;
		background-color: #6681FA;
	}

	.packages>>>.el-checkbox__label {
		display: none;
	}

	.packages>>>.el-form-item__content {
		width: 100%;
		display: block;
	}

	.el-form>>>.el-checkbox__label {
		font-size: 14px;
	}

	.wid-100>>>.el-form-item__content {
		flex: 1;
	}

	.el-form>>>.is-checked .el-checkbox__input.is-disabled+span.el-checkbox__label {
		color: #6883FB;
	}

	.el-form>>>.is-checked .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
		border-color: #6681FA;
		background-color: #6681FA;
	}

	.el-form>>>.el-radio.is-bordered.is-checked {
		border-color: #6681FA
	}

	.el-form>>>.is-checked .el-radio__input.is-disabled+span.el-radio__label {
		color: #6681FA;
	}

	.el-form>>>.is-checked .el-radio__input.is-disabled .el-radio__inner,
	.el-radio__input.is-disabled.is-checked .el-radio__inner {
		background-color: #6681FA;
	}

	.el-form>>>.el-form-item__error {
		position: absolute;
	}

	.personal>>>.el-form-item__label {
		float: none;
	}
	
	.personal >>> .el-radio-group{
		width: 100%;
		max-width: 400px;
	}
	
	.personal >>> .el-radio-group .el-radio{
		width: 100%;
	}
	
</style>
<style lang="scss" scoped>
	.personal {
		padding-top: 50px;

		.open-item-tip {
			position: absolute;
			top: -40px;
			left: 0px;
			width: 438px;
			height: 40px;
			padding: 0 16px;
			line-height: 40px;
			font-size: 18px;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #293033;
			background-color: #FFFFFF;
			box-shadow: 0px 1px 4px 0px #D7E0ED;
			border-radius: 2px;
		}

		.insert-title {
			position: relative;
			font-size: 16px;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #293033;
			line-height: 16px;
			padding-bottom: 15px;
			border-bottom: 1px solid #E5E8F5;
			margin-bottom: 8px;

			&::before {
				position: absolute;
				left: -24px;
				top: 0;
				content: '';
				width: 4px;
				height: 20px;
				background-color: #6883FB;
			}
		}

		.el-form {
			.el-form-item {


				.label {
					display: flex;
					justify-content: flex-end;
					color: #777F8F;
				}

				.el-input,
				.el-select {
					width: 100%;
					max-width: 400px;
				}

				.tip {
					line-height: 12px;
					margin-top: 6px;
					color: #ACAEB3;
				}

				.product {
					width: 193px;
					height: 56px;
					line-height: 18px;
					border-radius: 6px 0 6px 0;
					cursor: pointer;

					.name {
						top: 50%;
						left: 50%;
						width: 100%;
						transform: translate(-50%, -50%);
					}

					&.basic {
						color: #40444D;
						background-color: #F0F4F7;
					}

					&.PLM {
						color: #C07E37;
						background-color: #FCF9F0;
					}

					&.comorbidity {
						color: #C92B5C;
						background-color: #FCF5F2;
					}

					&.illness {
						color: #5843BE;
						background-color: #F6F5FC;
					}

					&.health {
						color: #1955AF;
						background-color: #F0F6FC;
					}
				}

				p.base-count {
					width: 193px;
					margin-bottom: 16px;
				}

				.count {
					font-size: 13px;
					line-height: 13px;
					color: #777F8F;
					margin-top: 6px;
				}
			}

			.packages {
				width: 100%;
				margin: 16px 0 0;

				.el-checkbox-group {
					display: flex;
					flex-wrap: wrap;

					div.qjc-fl {
						margin-right: 16px;
					}

					.c-danger {
						color: #FF4C52;
					}
				}
			}

			h3 {
				margin: 40px 0 24px;
			}

			.footer-btn {
				display: flex;
				justify-content: center;
				align-items: center;
				margin-top: 40px;
			}

			.next {
				width: 96px;
				height: 34px;
				border-radius: 17px;
				border: none;
				font-size: 14px;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 400;
				color: #fff;
			}

			.prev {
				width: 96px;
				height: 34px;
				border-radius: 17px;
				border: 1px solid #6883FB;
				font-size: 14px;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #6883FB;
				background-color: #fff;
				margin-right: 24px;
			}
		}
	}


	.wid-100 {
		display: flex;
		width: 100% !important;
	}

	.package {}

	.package-radio {

		.el-radio.is-bordered {
			width: 100%;
			max-width: 400px;
		}
	}

	.custom-box {
		width: 100%;
		padding: 12px;
		border: 1px solid #DBDDE6;
	}

	.wid-100 .el-form-item__content {
		flex: 1;
	}
</style>